import { cn } from '../../utils/helpers';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 font-medium transition-colors rounded-sm',
        'focus:outline-none focus:ring-1 focus:ring-accent',
        // Variants
        variant === 'primary' && 'bg-accent text-white hover:bg-accent-hover disabled:opacity-50',
        variant === 'secondary' && 'bg-bg-input border border-border text-text-primary hover:bg-bg-hover',
        variant === 'ghost' && 'text-text-secondary hover:text-text-primary hover:bg-bg-hover',
        variant === 'danger' && 'bg-status-critical text-white hover:bg-red-600 disabled:opacity-50',
        // Sizes
        size === 'sm' && 'px-2.5 py-1 text-xs',
        size === 'md' && 'px-4 py-2 text-sm',
        size === 'lg' && 'px-6 py-2.5 text-base',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
